import React, { useEffect, useState, useContext } from 'react'
import { Grid, Typography } from '@material-ui/core'
import HeadTile from './HeadTile'
import { db } from '../../../../config/firebase'
import { UserContext } from '../../../../context/UserProvider'
import moment from 'moment-timezone'


export const CalculatedParametersTile = ({ data, style, col }) => {
	const { usuario, userTimezone } = useContext(UserContext);
	const uid = data.uid;
	console.log("Esto es data:",data)
	const cropId = uid.split("@")[0];
	const parameterId = uid.split("@")[2];
	const [parameterValue, setParameterValue] = useState("-");
	const [lastUpdate, setLastUpdate] = useState("");

	useEffect(() => {
		// Verificar que tenemos un usuario válido
		if (!usuario || !usuario.username) {
			console.log("No hay usuario válido para obtener datos");
			return;
		}

		// Crear la ruta del documento
		const docPath = `${usuario.username}/multiCrop/${cropId}/calculatedParameters/${parameterId}/data`;

		// Obtener referencia al documento
		const docRef = db.doc(docPath);

		// Suscribirse a los cambios del documento
		const unsubscribe = docRef.onSnapshot((docSnapshot) => {
			if (docSnapshot.exists) {
				const data = docSnapshot.data();
				console.log("Datos actualizados del parámetro calculado:", data);

				// Actualizar el estado con los datos recibidos
				if (data.value !== undefined) {
					setParameterValue(data.value);
				}

				if (data.lastUpdate !== undefined) {
					// Formatear la fecha usando moment-timezone
					const localDate = moment(data.lastUpdate).tz(userTimezone || 'America/Mexico_City').format("D/MM/YYYY, HH:mm [Hrs.]");
					setLastUpdate(localDate);
				}
			} else {
				console.log("No se encontró el documento de parámetros calculados");
			}
		}, (error) => {
			console.error("Error al escuchar cambios en el documento:", error);
		});

		// Limpiar la suscripción cuando el componente se desmonte
		return () => {
			console.log(`Cancelando suscripción para: ${docPath}`);
			unsubscribe();
		};
	}, [usuario, cropId, parameterId, userTimezone]); // Dependencias del efecto

  return (
	<Grid
	container
	direction="row"
	justifyContent="center"
	alignItems="center"  // Cambiado a "center" para centrar verticalmente.
	style={style}
	>
		<HeadTile name={data.nameOfCard} uid={uid} col={col} lastUpdate={lastUpdate} />
		<Grid
			item
			xs={6}
			container
			direction="column"
			alignItems="center"  // Alineación centrada de los elementos hijos.
			justifyContent="center"
			// className="parameter-grid"  // Clase CSS personalizada para aplicar estilos.
			>
			<Typography variant="subtitle2" gutterBottom>
				Valor
			</Typography>
			<h5>
				<span className="badge badge-dark value-badge">{parameterValue}</span>
			</h5>
		</Grid>
	</Grid>
  )
}
